import Http from '@/api/http.js'

export default {
  show(id) {
    return Http.get(`/companies/${id}`);
  }, 
  index(params){
    return Http.get(`/companies`, {
      params
    });
  },
  sicoobCredentials(){
    return Http.get(`/companies/sicoob_credentials`);
  },
  create(company){
    return Http.post(`/companies`, {company: {...company}})
  },
  update(company){
    return Http.put(`/companies/${company.id}`, {company: {...company}})
  },

}